import { NgModuleRef, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Utilities, sessionId } from '@approot/utilities';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { AppModule } from './app/app.module';
import './cds-icons';
import { environment } from './environments/environment';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

declare global {
  // interface declarations are merged with existing interface
  interface Window {
    sessionId: string;
    useRaygun: boolean;
    redactEntitiesInRaygun: boolean;
    ngRef: NgModuleRef<AppModule>;
  }
}

window.sessionId = sessionId();

LicenseManager.setLicenseKey(environment.agGridLicense);

if (environment.production) {
  enableProdMode();
  if (window && Utilities.currentEnvironment() === 'prod') {
    window.console.log = function () {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(ref => {
    // Ensure Angular destroys itself on hot reloads.
    if (window.ngRef) {
      window.ngRef.destroy();
    }
    window.ngRef = ref;
  })
  .catch(err => console.error('bootstrap', err));
